/* eslint-disable */
export const fr = {
    'QR код': 'Code QR',
    Бейдж: 'Badge',
    'Виджет с картой': 'Widget avec carte',
    Кнопка: 'Bouton',
    Ссылка: 'Lien',
    'widgetgenerator.erip.tooltip':
        "Il s'agit d'un code spécial qui est généré et attribué à chaque publicité publiée en ligne. Ce code est public, il est donc accessible à tous les utilisateurs sur Internet et est intégré aux paramètres du lien. Vous pouvez trouver le code ERID dans votre <a href='https://distribution.yandex.ru/v2/create/partner/go?utm_source=widget_generator'>compte</a> Yandex Distribution.",
    'widgetgenerator.legal.url.yandex': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.legal.url.yango': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.modal.continue': 'Continuer',
    'widgetgenerator.modal.message':
        "Le type de widget « Widget avec carte » n'est pas disponible pour cette adresse, veuillez utiliser un autre format de widget",
    'widgetgenerator.yandex.badge.orderInYandex': 'Commander avec Yandex Go',
    'widgetgenerator.yandex.defaultAddress': 'Moscou, Russie, 16 Ulitsa Lva Tolstogo',
    'widgetgenerator.yango.badge.getRidetitle': 'Commander une course',
    'widgetgenerator.yango.badge.orderInYango': 'Commander avec Yango',
    'widgetgenerator.yango.defaultAddress':
        'Deira, Dubaï, Émirats arabes unis, Aéroport international de Dubaï',
    Адрес: 'Adresse',
    'Адрес сайта или CLID партнерской программы': 'Adresse du site ou CLID du programme partenaire',
    'Без адреса': 'Aucune adresse',
    Бизнес: 'Business',
    'Введите авторизационные данные для доступа к API. Получить их можно':
        "Saisissez les identifiants permettant d'accéder à l'API. Vous pouvez les obtenir",
    'Вызвать такси': 'Commander une course',
    'Генератор виджета': 'Générateur de widget',
    'Доехать на такси': 'Commander une course',
    Заголовок: 'Titre',
    Загрузить: 'Charger',
    Комфорт: 'Confort',
    Копировать: 'Copier',
    Куда: 'Vers',
    'Маршрут, встроенный в ссылку': 'Itinéraire intégré dans le lien',
    Минивен: 'Monospace',
    'Нажимая «Получить код» вы соглашаетесь с':
        'En appuyant sur « Obtenir le code », vous acceptez',
    'Невозможно выбрать тариф: регион не поддерживается':
        'Classe de service indisponible : région non prise en charge',
    'Неправильный адрес': 'Adresse invalide',
    'Новый виджет': 'Nouveau widget',
    Откуда: 'Depuis',
    Подзаголовок: 'Sous-titre',
    'Получить код': 'Obtenir le code',
    'Скачать QR код': 'Télécharger le code QR',
    'Скопируйте код и установите на сайте': 'Copiez le code et intégrez-le à votre site',
    Стиль: 'Style',
    Стоимость: 'Prix',
    Тариф: 'Classe de service',
    'Текст успешно скопирован': 'Texte copié',
    'Указанный адрес': 'Adresse saisie',
    'Фоновое изображение': 'Image d’arrière-plan',
    Цена: 'Prix',
    Эконом: 'Éco',
    'Это поле обязательно': 'Champ obligatoire',
    'оставив заявку': 'en envoyant une demande',
    'условиями использования': 'les conditions générales',
};
